module.exports = __webpack_public_path__ + "static/media/example_page.5db002b4.png";